import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {ClientSidePermissionTeamLinkContainer} from '../../../../../models/aggregates/permissions';
import {Core2Config} from '../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class ClientSidePermissionTeamLinkService extends BaseApiTemplateService<ClientSidePermissionTeamLinkContainer> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
    + 'client-side-permission-group-links/applet-admin-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
      + 'client-side-permission-group-links/applet-admin-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
      + 'client-side-permission-group-links/applet-admin-ep';
    this.httpClient = http;
  }
}
